import Util from '@/lib/util'
import _ from "lodash";

export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
        align:"center"
      },
    {
        title:Util.L('Đối tác'),
        key:'clientName',
        width: 150,
    },{
        title:Util.L('Ngành hàng'),
        key:'categoryName',
        width: 120,
    },
    {
        title:Util.L('Mã sản phẩm'),
        key:'sku',
        width: 120,
    },
    {
        title:Util.L('Tên sản phẩm'),
        key:'name',
    },
    {
        type: "selection",
        width: 50,
        fixed: "right",
    }]